import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Menu from "@mui/material/Menu";
import React from "react";
// nodejs library to set properties for components

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// material-ui icons
import MoreVert from "@material-ui/icons/MoreVert";


import buttonStyles from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";
// import { getCourseId } from "../../reduxToolkit/features/course/CoursesSlice"
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteGAReport,
  fetchGAReports,
} from "../../reduxToolkit/features/GAReport/GAResportSlice";

import { useTranslation } from "react-i18next";
import { fetchStaff } from "reduxToolkit/features/user/UserSlice";
import AccessAndRoleModal from "./AccessAndRoleModal";
import SuperGeneralDeleteModal from "./SuperGeneralDeleteModal";
import { ListItemText } from "@material-ui/core";

const useButtonStyles = makeStyles(buttonStyles);

export default function DropDownButtonGAReport(props) {
  const { t } = useTranslation();
  const buttonClasses = useButtonStyles();
  const anchorRef = React.useRef(null);


  const dispatch = useDispatch();



  const delete_GAReport = (id) => {
    console.log("click for delete");
    try {
      dispatch(deleteGAReport(id))
        .then(unwrapResult)
        .then(() => {
          dispatch(fetchGAReports())
            .then(unwrapResult)
            .then((GAReports) => {
              props.GAWorkFlow(GAReports);
            });
        });
    } catch (err) {
      console.log("Failed to delete  the delete GA Reports : ", err);
    } finally {
    }
  };

  /*******************************************************************/
  React.useEffect(() => {
    dispatch(fetchStaff())
  }, [dispatch]);

  const staffStatus = useSelector((state) => state.user.staffStatus);

  const staffList = useSelector((state) => state.user.staffList);
  /******************************************************************/
  /******************************************************************
    *                          Handle Menu
    *****************************************************************/
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosebtn = () => {
    setAnchorEl(null);
  };
  const handleOpenDeleteModal = () => {
    setOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setOpen(false);
  };
  //const [op_en, setOpen] = React.useState(Boolean(anchorEl));
  const op_en = Boolean(anchorEl);
  // console.log(anchorEl)
  /*****************************************************************/
  return (
    <span>
      <Button
        info
        round
        ref={anchorRef}
        aria-controls={op_en ? "basic-menu" : undefined}
        aria-expanded={op_en ? "true" : undefined}
        aria-label="select merge strategy"
        aria-haspopup="true"
        onClick={handleClick}
        className={`${buttonClasses.justIcon} ${buttonClasses.round}`}
        id="basic-button"
      >
        <MoreVert />
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={op_en}
        onClose={handleClosebtn}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >

        <AccessAndRoleModal
          id={props.id}
          handleDropDownButtonClose={handleClosebtn}
          NameOfComponentUsed="GAs-Report"
          interface='reports'
          disabled={false}
          data={props.data}
          staffList={staffList}
          fetchGAReports={props.fetchGAReports}
        />

        <MenuList id="basic-menu">
        <MenuItem
          onClick={() => {
            handleOpenDeleteModal();
            //handleClose();
          }}
        >
          <ListItemText primary="Delete" />
        </MenuItem>
        <SuperGeneralDeleteModal
           delete_Element={delete_GAReport}
           Element_ID={props.GAReport_ID}
           open={open}
           handleClose={handleCloseDeleteModal}
        />
          {/* <MenuItem>
            <p onClick={() => delete_GAReport(props.GAReport_ID)}>
              {t("Delete")}
            </p>
          </MenuItem> */}
        </MenuList>
      </Menu>
    </span>
  );
}
